// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__22fPY","summary":"CartItem_summary__2c3T2","price":"CartItem_price__3xVKE","amount":"CartItem_amount__1pmIb","actions":"CartItem_actions__2_Coz"};